import { useState } from 'react';
import { Image } from 'semantic-ui-react';
import { AssetUtils } from '../../utils/assetsUtils';

type CompanyLogoPropsType = {
    companyId: number;
    className?: string;
    avatar?: boolean;
    hideOnError?: boolean;
};

const cashBustKey = Date.now();

function CompanyLogo({ companyId, className = '', avatar, hideOnError = false }: CompanyLogoPropsType) {
    const [failed, setFailed] = useState(false);
    const logoURL = AssetUtils.buildLogoURL(companyId);

    if (hideOnError && failed) {
        return null;
    }

    return <Image crossOrigin="anonymous" src={logoURL} alt="" className={className} avatar={avatar} onError={() => setFailed(true)} />;
}

export default CompanyLogo;
